import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const QuantityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0 0;
  gap: 5px;
`;

export const QuantityContent = styled.div`
  display: flex;
  gap: 6px;
`;

const QuantityItem = css`
  width: 38px;
  height: 30px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #afafaf;
  border-radius: 4px;
  outline: none;
`;

export const Input = styled.input`
  ${QuantityItem};
  font-family: ${({ theme }) => theme.fontFamily};
  text-align: center;
`;

export const Button = styled.button`
  ${QuantityItem};
  font-family: ${({ theme }) => theme.fontFamily};
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 500;
`;
